import uuid from "uuid";

export default {
    namespaced: true,
    state     : {
        validators: []
    },
    mutations : {
        push_validator(state, validator) {
            state.validators.push(validator);
        },
        delete_validator(state, id) {
            state.validators[id] = undefined;
        },

        add_errors(state, payload) {
            const validatorId = payload.id || null;
            const errors = payload.errors || null;
            const overwrite = payload.overwrite || false;
            const validator = state.validators.find(v => v.id === validatorId);
            if (validator) {
                if (overwrite) {
                    validator.errors.splice(0);
                }
                validator.errors.push(...errors);
            }
        },
        clear_errors(state, payload) {
            const validatorId = payload.id || null;
            const validator = state.validators.find(v => v.id === validatorId);
            if (validator) {
                if (Array.isArray(payload.except)) {
                    validator.errors = validator.errors.filter(e => payload.except.includes(e.attr));
                } else if (Array.isArray(payload.only)) {
                    validator.errors = validator.errors.filter(e => !payload.only.includes(e.attr));
                } else {
                    validator.errors = [];
                }
            }
        }
    },
    actions   : {
        add_validator({commit}, validator) {
            validator.id = uuid.v4();
            validator.errors = [];
            commit('push_validator', validator);
            return validator.id;
        }
    }
}
